import template from './index.jst';
import { View } from "backbone.marionette";
import { Model } from 'backbone';

let titles = function() {
	return {
		initial: 'Fantasy Coach Features',
		month: '2024 Monthly pass only $4.99 / month',
		season: '2024 Season pass only $19.99'
	}
};

export default class CoachFeaturesView extends View {
	get template() {
		return template;
	}

	className() {
		return 'coach-features';
	}

	initialize() {
		this.model = new Model({
			title: titles().initial
		});
	}

	init({ has_assistant_coach, selected_subscription_type, is_plan_payed }) {
		const title = is_plan_payed ? 'initial' : selected_subscription_type;

		if (has_assistant_coach) {
			this.model.set({
				title: titles()[title]
			});
		}

		this.render();
	}
}